export const FNB_ENDPOINTS = {
    GET_REVIEW_LIST: '/eifapi/review',
};
